import { render } from "./faqPage.vue?vue&type=template&id=4bcc33bc&scoped=true"
import script from "./faqPage.vue?vue&type=script&lang=js"
export * from "./faqPage.vue?vue&type=script&lang=js"

import "./faqPage.vue?vue&type=style&index=0&id=4bcc33bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bcc33bc"]])

export default __exports__